import { useEffect, useState } from 'react';
import { backend_url } from '../../App';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddReview = ({ onClose, productId }) => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        reviewTitle: '',
        review: '',
        rating: 0,
        showHide: false,
        reviewImage: null,
        productId: productId,
    });

    useEffect(() => {
        if (productId) {
            setFormData((prev) => ({
                ...prev,
                productId
            }));
        }
    }, [productId]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    };

    const handleStarClick = (rating) => {
        setFormData((prev) => ({
            ...prev,
            rating
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }

        try {
            const res = await fetch(`${backend_url}/api/customerreview`, {
                method: 'POST',
                body: form
            });
            if (res.ok) {
                toast.success("Review submitted successfully!");
                setTimeout(() => {
                    onClose();
                }, 5000);
            }
        } catch (err) {
            console.error('Error submitting review:', err);
        }
    };

    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                    <h2 className="text-xl font-bold mb-4">Write a Review</h2>
                    <form onSubmit={handleSubmit} className="space-y-3">
                        <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full border border-gray-300 rounded-lg px-3 py-2"
                            autoComplete='off'
                        />
                        <input
                            type="email"
                            name="email"
                            autoComplete='off'
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full border border-gray-300 rounded-lg px-3 py-2"
                        />
                        <input
                            type="text"
                            name="reviewTitle"
                            autoComplete='off'
                            placeholder="Review Title"
                            value={formData.reviewTitle}
                            onChange={handleChange}
                            required
                            className="w-full border border-gray-300 rounded-lg px-3 py-2"
                        />
                        <textarea
                            name="review"
                            placeholder="Write your review..."
                            value={formData.review}
                            onChange={handleChange}
                            required
                            rows="4"
                            maxLength={150}
                            autoComplete='off'
                            className="w-full border border-gray-300 rounded-lg px-3 py-2"
                        />
                        {/* Star Rating */}
                        <label>Select the star for our product</label>
                        <div className="flex space-x-2 justify-center text-yellow-400 text-6xl">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    onClick={() => handleStarClick(star)}
                                    className={`cursor-pointer ${formData.rating >= star ? 'text-yellow-500' : 'text-gray-300'}`}
                                >
                                    ★
                                </span>
                            ))}
                        </div>
                        <div>
                            <label htmlFor="reviewImage" className="block text-gray-500 mb-1">
                                Upload Image
                            </label>
                            <input
                                type="file"
                                name="reviewImage"
                                onChange={handleChange}
                                accept="image/*"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                            />
                        </div>
                        <div className="flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={onClose}
                                className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded-lg"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="bg-[#945bd1] hover:bg-[#623394] text-white px-4 py-2 rounded-lg"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <ToastContainer />
        </>
    );
};

export default AddReview;
